/* eslint-disable import/prefer-default-export */

import modalActionTypes from './Modal-ActionTypes';

export const toggleConfirmModal = (isOpen) => ({
    type: modalActionTypes.TOGGLE_CONFIRM_MODAL,
    payload: isOpen,
});
